<template>
  <v-container fluid :class="containerClasses" class="text-center mb-2 bg-red-darken-3">
    <!-- Header -->
    <div class="text-center mb-2">
      <h1 :class="titleClasses">Q&A</h1>
      <p :class="subtitleClasses">
        Antworten auf häufige Fragen
      </p>
    </div>
    <v-expansion-panels
      accordion
      :class="[columnClasses, responsiveWidth]"
      class="mt-4  mx-auto"

      v-for="(item, index) in simpleFaq"
      :key="index"
    >
      <v-expansion-panel class="rounded-s-shaped elevation-2 ">
        <v-expansion-panel-title  
          :class="[bodyTextClasses]"
          class="bg-red-lighten-5 font-weight-bold"
          >
          {{ item.question }}
        </v-expansion-panel-title>

        <v-expansion-panel-text  
          :class="[bodyTextClasses]"
          class="bg-grey-lighten-5 text-left"
        >
          {{ item.answer }}
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>


    <!-- Contact -->
    <div class="text-center mt-6">
      <v-btn 
        text 
        color="primary"
        class="mt-2"
        :size="buttonSize"
      >
        Mehr Fragen? Kontaktiere mich
      </v-btn>
    </div>
  </v-container>
</template>

<script lang="ts">
import { defineComponent, ref } from 'vue';
import { useResponsive } from '@/composables/useResponsive';

export default defineComponent({
  name: 'AqComponent',
  
  emits: ['navigate-to'],
  
  setup() {
    // Responsive-Funktionen
    const responsive = useResponsive();
    
    // FAQ-Daten
    const simpleFaq = ref([
      {
        question: 'Wie lange vorab sollte ich buchen?',
        answer: 'Am besten 4-6 Wochen im Voraus, besonders für Wochenend-Termine.'
      },
      {
        question: 'Was kostet ein Fotoshooting?',
        answer: 'Die Preise richten sich nach Art und Umfang. In der Beratung erstelle ich ein individuelles Angebot.'
      },
      {
        question: 'Bearbeitest du alle Fotos?',
        answer: 'Ja, jedes ausgewählte Bild wird professionell bearbeitet.'
      },
      {
        question: 'Gibt es ein Shooting-Paket?',
        answer: 'Ja, ich biete verschiedene Pakete an – vom Basic-Shooting bis zum Premium-Paket.'
      }
    ]);
    
    
    return {
      // FAQ-Daten
      simpleFaq,
      
      // Responsive Properties
      ...responsive,
      
      // Computed Properties
      
      // Methods
    };
  }
});
</script>

<style scoped>
</style>